import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogMaterial } from "../../../models/CatalogMaterial";
import { useCatalogMaterialContext } from "../context/CatalogMaterialContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setMaterial: (material: CatalogMaterial) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setMaterial,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogMaterialContext();

  const rows: CatalogMaterial[] =
    state.materials?.map((material) => ({
      ...material,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "MaterialName",
      headerName: "Name",
      minWidth: 20,
      flex: 3,
      cellStyle: cellStyle,
    },
    {
      field: "L1MaterialId",
      headerName: "L1 Material ID",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "IsAlloy",
      headerName: "Is Alloy",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "UseInEAF",
      headerName: "Use in EAF",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "UseInLF",
      headerName: "Use in LF",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setMaterial,
        data: params.data as CatalogMaterial,
        del: false,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "materialContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];

  return { rows, columnDefs };
};
